import request from '@/utils/request' // 引入封装的request.js文件

// 获取用户信息
export function getInfo(query) {
  return request({
    url: '/getInfo',
    method: 'get',
    params: query
  })
}

// 修改密码
export function changePwd(query) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: query
  })
}